export const FILL_LIST = 'FILL_LIST';
export const FILL_ACTIVE_CAMPAIGN = 'FILL_ACTIVE_CAMPAIGN';
